import React from "../../__compat__/react/main.entry.mjs.mjs";
import { StyledTableHeader } from "./Table.styles.mjs.mjs";
import { TableContext } from "./Table.context.mjs.mjs";
export const TableHeader = React.forwardRef((props, ref) => {
    const tableContext = React.useContext(TableContext);
    return (React.createElement(StyledTableHeader, { ...props, ref: ref, role: "rowgroup", displayMode: tableContext.displayMode }, props.children));
});
TableHeader.displayName = 'TableHeader';
//# sourceMappingURL=TableHeader.mjs.mjs.map